import Choices from 'choices.js';

const choiceEl = document.querySelector('.c-select__control');

if (choiceEl) {
  const choices = new Choices(choiceEl,{
    searchEnabled: false
  })

  choices.init()
}
